import produce from 'immer'
import { CaseworkerActionType } from '../../action-types'
import { CaseworkerAction } from '../../actions'
import { ApiValidationErrors } from '../../../ts/api-types'

export interface CaseworkerTeamState {
    caseworkers: unknown[]
    fetchCaseworkersLoading: boolean
    selectedCaseworker: unknown | null
    newCaseworkerValidationErrors: ApiValidationErrors | unknown[]
}

const initialState: CaseworkerTeamState = {
    caseworkers: [],
    fetchCaseworkersLoading: false,
    selectedCaseworker: null,
    newCaseworkerValidationErrors: [],
}

const reducer = produce(
    (
        state: CaseworkerTeamState = initialState,
        action: CaseworkerAction
    ) => {
        switch (action.type) {
            case CaseworkerActionType.ADD_CASEWORKER:
                state.caseworkers.push(action.payload)
                return state

            case CaseworkerActionType.GET_ALL_CASEWORKERS:
                state.fetchCaseworkersLoading = false
                state.caseworkers = action.payload
                return state

            case CaseworkerActionType.SET_FETCH_CASEWORKERS_LOADING:
                state.fetchCaseworkersLoading = true
                return state

            case CaseworkerActionType.GET_SINGLE_CASEWORKER:
                state.selectedCaseworker = action.payload
                return state

            case CaseworkerActionType.SHOW_CREATE_CASEWORKER_VALIDATION_ERRORS:
                state.newCaseworkerValidationErrors = action.payload
                return state

            case CaseworkerActionType.ADD_CASEWORKER_VALIDATION:
                return state

            case CaseworkerActionType.CLEAR_CASEWORKER_VALIDATION_ERRORS:
                state.newCaseworkerValidationErrors = []
                return state

            default:
                return state
        }
    }
)

export default reducer
